import { Button } from '@usitsdasdesign/dds-react'
import Heading from 'atoms/Heading'
import Icon from 'atoms/Icon'

const PositionStyle = {
  'left' : 'left-0',
  'right' : 'right-0'
}

function ActionDropBox({ children, label, onClose, buttons = [], height = 'h-full md:h-80', width = 'md:w-[19rem]',  position = 'left', disableSave = false }) {
  return (
    <div className={`fixed border border-gray-200 overflow-hidden top-0 md:top-[auto] md:absolute z-[100] bg-white md:p-3 flex flex-col md:justify-between ${width} shadow-drop md:mt-1.5 w-full ${PositionStyle[position]} ${height}`}>
      <div className="flex-none md:hidden p-2 flex items-center justify-between mb-5">
        <Heading type="h5">{label}</Heading>
        <Icon icon="close__l__stroke" onClick={onClose} />
      </div>
      <div className='flex-1 px-3 md:px-0 overflow-y-auto overflow-x-hidden'>
        {children}
      </div>
      {
        (buttons?.length > 0 && !disableSave) && (
          <div className='md:border-t mt-1 flex justify-end md:justify-center px-3 shadow-boxed md:shadow-none pt-3 pb-3 md:pb-0 flex-none gap-4'>
            {
              buttons.map((button, i) => {
                return (
                  <Button
                    {...button}
                  />
                )
              })
            }
          </div>
        )
      }
    </div>
  )
}

export default ActionDropBox